export default "__VITE_ASSET__d51e3cd8__"